/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  firebase: {
    apiKey: 'AIzaSyBJeOeOx8lZjyB0kYMXK5dYStwO1Ixrmic',
    authDomain: 'echotree-dev.firebaseapp.com',
    projectId: 'echotree-dev',
    storageBucket: 'echotree-dev.firebasestorage.app',
    messagingSenderId: '480421068110',
    appId: '1:480421068110:web:b9b60652b37db70cfe321f',
    measurementId: 'G-16BRZK6FCV',
  },
  threadsAiugcApiURL: 'https://asia-east1-echotree-dev.cloudfunctions.net/generateThreadsAiugcProfile',
  production: false,
};
